import * as React from 'react';
import injectSheet, { JSSClassesProps } from 'react-jss';

import {
    ContentLoader as _ContentLoader,
    ContentLoaderProps,
} from 'sletat-ui-components/lib/ContentLoader';
import { basicClasses } from 'sletat-ui-components/lib/ContentLoader/themes/basic';

import { ComponentJSSClasses } from './styles';

const ContentLoader = injectSheet<ContentLoaderProps>(basicClasses)(
    _ContentLoader
);

export interface PhotoGalleryPlaceholderProps { }

export interface StyledPhotoGalleryPlaceholderProps
    extends JSSClassesProps<ComponentJSSClasses>,
    PhotoGalleryPlaceholderProps { }

export function PhotoGalleryPlaceholder(
    props: StyledPhotoGalleryPlaceholderProps
) {
    const { classes } = props;

    return (
        <div className={classes.photoGallery}>
            <div className={classes.leftPhoto}>
                <img
                    className={classes.image}
                    src={
                        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiA5Ij48cmVjdCBmaWxsPSIjZTZlOWVhIiB3aWR0aD0iMTYiIGhlaWdodD0iOSIvPjwvc3ZnPgo='
                    }
                    alt={'Загрузка'}
                />
                <ContentLoader />
            </div>
            <div className={classes.rightPhoto}>
                <img
                    className={classes.image}
                    src={
                        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiA5Ij48cmVjdCBmaWxsPSIjZTZlOWVhIiB3aWR0aD0iMTYiIGhlaWdodD0iOSIvPjwvc3ZnPgo='
                    }
                    alt={'Загрузка'}
                />
                <ContentLoader />
            </div>
        </div>
    );
}
